import FileUploaderV2 from '@core/components/ApplyDialogV2/FileUploaderV2'
import FileUploaderV2List from '@core/components/ApplyDialogV2/FileUploaderV2List'
import type { FileError } from '@core/app/types'
import React, { useState } from 'react'

const ApplyV2CvStep = () => {
    const [files, setFiles] = useState<File[]>([])
    const [fileErrors, setFileErrors] = useState<FileError[]>([])
    return (
        <div>
            <FileUploaderV2 onChange={setFiles} onError={setFileErrors} />
            <FileUploaderV2List files={files} fileErrors={fileErrors} />
        </div>
    )
}

export default ApplyV2CvStep
